import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class ResultList extends PureComponent {

  static propTypes = {
    results: PropTypes.arrayOf(PropTypes.object),
    selectedIndex: PropTypes.number,
    labelKey: PropTypes.string,
    onSelect: PropTypes.func
  }

  static defaultProps = {
    results: [],
    selectedIndex: -1,
    labelKey: 'label',
    onSelect: () => {}
  }

  onClick = (index) => {
    this.props.onSelect(index);
  }

  renderListItems = () => {
    return this.props.results.map((d, i) => {
      const liClasses = classnames('result-list-item', {
        active: this.props.selectedIndex === i
      });

      return (
        <li
          dangerouslySetInnerHTML={{__html: d[this.props.labelKey]}}
          onClick={() => this.onClick(i)}
          key={d[this.props.labelKey]}
          className={liClasses}
        />
      );
    });
  }

  render() {
    const isEmpty = !this.props.results || !this.props.results.length;
    const resultListClasses = classnames('result-list', { hidden: isEmpty });

    return (
      <ul className={resultListClasses}>
        {!isEmpty && this.renderListItems()}
      </ul>
    )
  }
}

export default ResultList;
